const folder = {
  getFolder: (folderId) => ({
    method: "GET",
    path: `/folders/${folderId}`,
  }),
  updateFolder: (folderId) => ({
    method: "PATCH",
    path: `/folders/${folderId}`,
  }),
  deleteFolder: (folderId) => ({
    method: "DELETE",
    path: `/folders/${folderId}`,
  }),
  createFolder: {
    method: "POST",
    path: `/folders/`,
  },
  addItem: (folderId) => ({
    method: "POST",
    path: `/folders/${folderId}/entries`,
  }),
  removeItem: (folderId, folderEntryId) => ({
    method: "DELETE",
    path: `/folders/${folderId}/entries/${folderEntryId}`,
  }),
  reorderItems: (folderId) => ({
    method: "PATCH",
    path: `/folders/${folderId}/entries/reorder`,
  }),
  resolvePath: { method: "GET", path: "/folders/resolve-path" },
};

export default folder;
